import { IconStyle } from './Icon.style'

export interface IconProps {
  src: string
  alt: string
  paddingLeft?: string
  paddingRight?: string
  height?: string
  width?: string
}

export const Icon = (props: IconProps) => {
  const icon_path = props.src
  return (
    <IconStyle
      height={props.height}
      width={props.width}
      paddingLeft={props.paddingLeft}
      paddingRight={props.paddingRight}
    >
      <img src={icon_path} alt={props.alt} />
    </IconStyle>
  )
}
